import { logError } from 'calling-cross-tab-library/utils/logError';
import { waitForSharedWorkerConnectionSingleton } from './waitForSharedWorkerConnectionSingleton';
export const sendCrossTabMessage = message => waitForSharedWorkerConnectionSingleton().then(asyncInstance => {
  if (asyncInstance) asyncInstance.sendMessage(message);
}).catch(error => {
  logError(error);
});